


// import React from "react";
// import { Link } from "react-router-dom";

// const normalizePannaLatestNews = (raw) => {
//   if (!Array.isArray(raw) || raw.length === 0) return [];

//   const section = raw[0];
//   const ni = section.newsItems?.[0] || {};

//   const titles = ni.title || [];
//   const images = ni.imageUrl || [];
//   const categories = ni.category || [];
//   const dates = ni.publishDate || [];

//   const max = Math.max(
//     titles.length,
//     images.length,
//     categories.length,
//     dates.length
//   );

//   return Array.from({ length: max }).map((_, i) => ({
//     title: titles[i] || "",
//     imageUrl: images[i] || "",
//     category: categories[i] || "",
//     publishDate: dates[i] || "",
//     _id: `${ni._id}_${i}`,
//   }));
// };

// const PannaLatestNews = ({ data }) => {
//   const list = normalizePannaLatestNews(data);
//   const sectionTitle = data?.[0]?.sectionTitle || "पन्ना की ताज़ा खबरें";

//   if (list.length === 0)
//     return <h3 className="text-center">No News Found</h3>;

//   // सभी items को small blocks में distribute करेंगे, कोई big block नहीं
//   return (
//     <section
//       className="bg-body section-space-less30"
//       style={{ marginTop: "-50px" }}
//     >
//       <div className="container">
//         <div className="ne-isotope">
//           <div className="row">
//             <div className="col-12">
//               <div className="topic-border color-azure-radiance mb-30">
//                 <div className="topic-box-lg color-azure-radiance">
//                   {sectionTitle}
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="featuredContainer">
//             <div className="row">
//               {/* सभी news items को small blocks में distribute करें */}
//               {list.map((item) => (
//                 <div
//                   key={item._id}
//                   className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 mb-30"
//                 >
//                   <div className="position-relative">
//                     <Link className="img-opacity-hover" to={`/news/${item._id}`}>
//                       <img
//                         src={item.imageUrl}
//                         alt={item.title}
//                         className="img-fluid width-100 mb-15"
//                         style={{ height: "200px", objectFit: "cover" }}
//                       />
//                     </Link>

//                     <div className="topic-box-top-xs">
//                       <div className="topic-box-sm color-cod-gray mb-10">
//                         {item.category}
//                       </div>
//                     </div>

//                     <div className="post-date-dark">
//                       <ul>
//                         <li>
//                           <span>
//                             <i
//                               style={{ color: "black" }}
//                               className="fa fa-calendar"
//                               aria-hidden="true"
//                             />
//                           </span>
//                           {item.publishDate}
//                         </li>
//                       </ul>
//                     </div>

//                     <h3 className="title-medium-dark size-md">
//                       <Link to={`/news/${item._id}`}>{item.title}</Link>
//                     </h3>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default PannaLatestNews;








import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const PannaLatestNews = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // ---------- DEFAULT STATIC DATA ----------
  const defaultData = {
    main_news: {
      featured: {
        title: "ब्रेकिंग न्यूज़ की ताज़ा खबरें",
        category:
          "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार; रेस्क्यू जारी – Uttarkashi News",
        date: "2017-03-22T17:49",
        // image: "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp",
        image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766689123/ezgif-5530dd1da8b37c_1759988348_zs5bii.webp"
      },

      list: [
        {
          title: "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार",
          // image:
          //   "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688154/live-update-centre-2025-10-09t081936484_1759978108_amjvky.webp",
          category: "News",
          date: "2017-03-22T17:50",
          description: "मध्य प्रदेश में 23 बच्चों की मौत का कारण बना कफ सिरप...",
        },
        {
          title: "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर",
          // image: "/assets/img/ezgif-25eec5267e400a_1759978236.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/ezgif-25eec5267e400a_1759978236_l0w35c.webp",
          category: "News",
          date: "2017-03-22T02:34",
          description:
            "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस अब तूल...",
        },
        {
          title: "नागपुर से मिला था छिंदवाड़ा को मौत का अलर्ट",
          // image: "/assets/img/11-1_1759952360.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/11-1_1759952360_dcagf4.webp",
          category: "News",
          date: "2017-03-22T02:34",
          description:
            "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से बच्चों की मौतों को टाला जा सकता था...",
        },
      ],
    },
  };

  // ---------- FETCH DATA ----------
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}api/v1/users/latestNews/all`
        );

        if (!isMounted) return;

        const apiData =
          res?.data?.data && Array.isArray(res.data.data)
            ? res.data.data[0]
            : null;

        setData(apiData || defaultData);
      } catch (err) {
        console.error("Error fetching latest news:", err);
        setData(defaultData);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();
    return () => (isMounted = false);
  }, []);

  if (loading || !data) return <div>Loading...</div>;

  const featured = data.main_news?.featured;
  const list = data.main_news?.list || [];

  return (
    <section className="section-space-bottom-less30 mt-lg-5">
      <div className="container">
        {/* TITLE BAR */}
        <div className="topic-border color-cod-gray mb-30">
          <div className="topic-box-lg color-cod-gray">{featured?.title}</div>
        </div>

        {/* ---------- FEATURED TOP NEWS ---------- */}
        <div className="featured-news-card mb-5">
          <img
            src={Array.isArray(featured?.image) ? featured.image[0] : featured?.image}
            alt="featured"
            className="featured-image"
            onError={(e) => (e.target.src = "/assets/img/placeholder.jpg")}
          />

          <div className="featured-overlay">
            <span className="cat-badge">{featured?.title}</span>

            <h1 className="featured-title">
              <Link to="/news_info">{featured?.category}</Link>
            </h1>

            <p className="featured-date">
              <i className="fa fa-calendar"></i>{" "}
              {new Date(featured?.date).toLocaleDateString()}
              <i className="fa fa-share-alt" style={{ fontSize: "25px", margin: "10px" }} />
              <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", margin: "10px" }} />
              <i className="fa fa-commenting-o" style={{ fontSize: "25px", margin: "10px" }} />
            </p>
          </div>
        </div>

        {/* ---------- NEWS LIST (GRID) ---------- */}
        <div className="row" style={{marginTop:"40px"}}>
          {list.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="news-card">
                <Link to="/news_info">
                  <img
                    src={Array.isArray(item.image) ? item.image[0] : item.image}
                    alt="news"
                    className="news-img"
                    onError={(e) =>
                      (e.target.src = "/assets/img/placeholder.jpg")
                    }
                  />
                </Link>

                <div className="news-content">
                  <span className="news-cat">{item.category}</span>

                  <h3 className="news-title">
                    <Link to="/news_info">{item.title}</Link>
                  </h3>

                  <p className="news-desc">{item.description}</p>

                  <p className="news-date" style={{ color: "black", fontSize: "16px", fontFamily: "sans-serif" }}>
                    <i className="fa fa-calendar" style={{ color: "black", margin: "10px" }}></i>
                    {new Date(item.date).toLocaleDateString()}
                    <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                    <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                    <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "black", margin: "10px" }} />

                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PannaLatestNews;


